import httpClient from "@/plugins/axios";

export const globalSearch = async (query, type = null, offset = 0) => {
    const params = {
        q: query,
    };
    if (type) {
        params.type = type;
        params.offset = offset;
    }
    const response = await httpClient.get('v1/search/', {
        params: params
    });
    return response;
}
